import { useState } from "react";
import CareBalanceModal from "./modals/CareBalanceModal";
import { useTranslation } from "react-i18next";
import { formatAsMoney } from "./utils/format-as-money";
import useResponsive from "./hooks/useResponsive";
import { careBalanceStatusMap } from './constants/careBalanceStatusMap';

const infoCircleWhite = "/img/care-balance/info-circle-white.svg";

function LowBalanceAlert({ t, isMobile, history }) {
  return (
    <div
      style={{
        backgroundColor: "#DF1C41",
        paddingBlock: "12px",
        paddingInline: "16px",
        display: "flex",
        alignItems: "center",
        gap: "16px",
        alignItems: isMobile ? "flex-start" : "center",
        justifyContent: "space-between",
        width: "100%",
        flexDirection: isMobile ? "column" : "row",
      }}
    >
      <div
        style={{
          display: "flex",
          alignItems: "center",
          gap: "8px",
        }}
      >
        <img
          src={infoCircleWhite}
          style={{
            width: "24px",
            height: "24px",
          }}
        />

        <p
          style={{
            color: "#ffffff",
            fontSize: "1.4rem",
            lineHeight: "20px",
            letterSpacing: "0px",
          }}
        >
          {t("fundInactiveAlertTitle")}
        </p>
      </div>

      <button
        style={{
          fontWeight: 500,
          fontSize: "1.6rem",
          lineHeight: "100%",
          letterSpacing: "0%",
          color: "#ffffff",
          textWrap: "nowrap",
        }}
        onClick={() => history?.push("/fund-care-balance")}
      >
        {t("fundButtonLabel")}
      </button>
    </div>
  );
}

export default function CareBalanceInfo({
  wallet,
  history,
  activeStatusId,
}) {
  const { t } = useTranslation("careBalance");

  const [showModal, setShowModal] = useState(false);

  const { isMobile } = useResponsive();

  const status = careBalanceStatusMap.get(activeStatusId);

  const showLowBalanceAlert = status !== "Active";

  return (
    <>
      <div
        style={{
          backgroundColor: "#ffffff",
          padding: "20px",
          gap: "16px",
          display: "flex",
          flexDirection: "column",
          marginBottom: "16px",
        }}
        data-testid="care-balance-info-card"
      >
        {showLowBalanceAlert && (
          <LowBalanceAlert t={t} history={history} isMobile={isMobile} />
        )}

        <div
          style={{
            display: "flex",
            justifyContent: "space-between",
            alignItems: isMobile ? "flex-start" : "center",
            gap: "16px",
            flexDirection: isMobile ? "column" : "row",
          }}
        >
          <div style={{ display: "flex", flexDirection: "column", gap: "8px" }}>
            <div
              style={{
                display: "flex",
                columnGap: "8px",
                alignItems: "center",
              }}
            >
              <h3
                style={{
                  color: "#4F4F4F",
                  fontWeight: 700,
                  fontSize: "1.6rem",
                  lineHeight: "24px",
                  letterSpacing: "0%",
                }}
              >
                {t("fundCareBalance")}
              </h3>
              <button
                style={{
                  color: "#107BC0",
                  textDecoration: "underline",
                  fontSize: "1.2rem",
                  lineHeight: "24px",
                  letterSpacing: "0%",
                }}
                onClick={() => setShowModal(true)}
              >
                {t("learnMore")}
              </button>
            </div>

            <h3
              style={{
                color: "#212121",
                fontWeight: 700,
                fontSize: "3.2rem",
                lineHeight: "24px",
                letterSpacing: "0%",
              }}
              data-testid="care-balance-amount"
            >
              {formatAsMoney({
                value: wallet?.balance?.available,
                currency: wallet?.currency,
              })}
            </h3>
          </div>

          <button
            style={{
              border: "1px solid #094063",
              color: "#094063",
              borderRadius: "4px",
              padding: "11px",
              fontWeight: 900,
              fontSize: "1.5rem",
              lineHeight: "2.4rem",
              letterSpacing: "0%",
            }}
            onClick={() => history?.push("/fund-care-balance")}
            data-testid="fund-care-balance-button"
          >
            {t("fundButtonLabel")}
          </button>
        </div>
      </div>

      {showModal && (
        <CareBalanceModal onClose={() => setShowModal(false)} t={t} />
      )}
    </>
  );
}
